export const getEsmColor = (value) => {
  if (value === 100) {
    return "#0b7348";
  } else if (value === 80) {
    return "#41a67c";
  } else if (value === 50) {
    return "#73cd57";
  } else if (value === -1) {
    return "#ff0102";
  } else {
    return "#FFF";
  }
};

export const getEsmColorByPercent = (value) => {
  if (value >= 80) {
    return "#0b7348";
  } else if (value < 80 && value >= 60) {
    return "#42A67C";
  }
  else if (value < 60 && value >= 40) {
    return "#FFCC03";
  }
   else if (value < 40 && value >= 20) {
    return "#FF8C02";
  } else if (value < 20) {
    return "#ff0102";
  }
}